var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('a',{staticClass:"btn btn-primary btn-block",attrs:{"target":"_blank","rel":"noopener noreferrer"},on:{"click":_vm.resize}},[_vm._v(" Ticket ")])])}
var staticRenderFns = []

export { render, staticRenderFns }